/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import { hmsAPI } from '@/api'

export const getOverlay =  overlayId => hmsAPI.get(`/overlays/${overlayId}`)
export const sendCompareToSegmentation =  compareId => hmsAPI.post(`/compares/${compareId}/apply-segmentation`)
export const updateOverlay =  (overlayId, overlay) => hmsAPI.put(`/overlays/${overlayId}`, overlay)
